import { Component, Prop, h, State, Element } from '@stencil/core'
import {LINK_RELATIONSHIPS, LINK_TARGETS, ICON_TYPES, TEXTLINK_VARIANTS_TYPES, SNAPLINK_FONT_TYPES} from '../../utils'
import { isBlank } from '../../utils'

@Component({
  tag: 'snap-link',
  styleUrl: 'snap-link.scss',
  shadow: true,
})
export class SnapLink {
  private remove: HTMLElement
  /**
   * Determines link behavior. Only valid for links.
   */
  @Prop({ reflect: true }) href: string
  /**
   * Determines how links open.
   */
  @Prop({ reflect: true }) target: LINK_TARGETS = '_self'
  /**
   * Specifies which referrer to use when fetching the resource
   */
  @Prop({ reflect: true }) rel: LINK_RELATIONSHIPS
  /**
   * Label for the link. Aria labels describe the purpose of a link in HTML
   */
  @Prop() label: string
  /**
   * The text of this link.
   */
  @Prop({ reflect: true }) text: string = ''
  /**
   * Does this link get a link icon
   */
  @Prop({ reflect: true }) icon: ICON_TYPES | undefined

  @Prop({ reflect: true }) srOnly: string = ''

  @Prop({ reflect: true }) size: 'xs' | 'sm' | 'base' = 'base'

  @Prop({ reflect: true }) variant: TEXTLINK_VARIANTS_TYPES = 'default'

  @Prop({ reflect: true }) disabled = false

  @Prop({ reflect: true }) iconPosition: 'left' | 'right' = 'left'

  @Prop({ reflect: true }) font: SNAPLINK_FONT_TYPES = 'bold'

  @Element() private element: HTMLElement

  @State() useIcon = false

  el = ''

  componentWillLoad() {
    if (!isBlank(this.icon)) {
      this.useIcon = true
    }
    this.el = this.element.textContent.trim()
  }

  componentDidLoad() {
    if (this.remove) {
      this.remove.remove()
    }
  }

  renderIcon() {
    if (this.useIcon) {
      let size
      this.size === 'base' ? size = 'sm' : size = 'xs'
      return <snap-icon icon={this.icon} size={size}></snap-icon>
    }
  }

  renderSrOnly() {
    if (!isBlank(this.srOnly)) {
      return <span class="sr-only">{this.srOnly}</span>
    }
  }

  getClassNames() {
    let classes = `snap-link snap-link--${this.size} snap-link--${this.variant} snap-link--${this.font} snap-link--icon-${this.iconPosition}`
    if (this.useIcon && this.text) {
      classes += ' snap-link--with-icon'
    } else if (this.useIcon && !this.text) {
      classes += ' snap-link--icon-only'
    }

    this.disabled ? classes += ' disabled' : null
    return classes
  }

  render() {
    return [
      <a
        class={this.getClassNames()}
        href={this.href ? this.href : null}
        rel={this.rel}
        target={this.href ? this.target : null}
        aria-label={this.label}>
        {this.iconPosition === 'left' && this.renderIcon()}
        {this.renderSrOnly()}
        <span class="snap-link-text-container">
          {this.el ? this.el : this.text}
        </span>
        {this.iconPosition === 'right' && this.renderIcon()}
      </a>,
      <span class="to-remove" ref={ref => (this.remove = ref)}>
        <slot />
      </span>,
    ]
  }
}
